import React__default from 'react';
import PropTypes from 'prop-types';
import { cssClassPrefix } from '../../../shared/constants/generalConstants.js';

/**
 * Copyright 2020, IntraLinks, Inc, All rights reserved.
 */
var BASE_CSS = "".concat(cssClassPrefix, "-header-content");

/**
 * IlHeaderContent Component
 * ```html
 * <IlHeaderContent>
 *   <!-- Other Custom Components -->
 * </IlHeaderContent>
 * ```
 */
var IlHeaderContent = function IlHeaderContent(props) {
  return /*#__PURE__*/React__default.createElement("div", {
    className: BASE_CSS
  }, props.children);
};
IlHeaderContent.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

export { IlHeaderContent as default };
